/**
 * PATH: apps/qa/src/pages/inspectionRecordLink.tsx
 * FILE_ID: QA-INSPECTION-RECORD-LINK-001
 * PURPOSE: Inspection rows open the QA hub editor, not the jobs shell.
 */
import type { ReactNode } from 'react'
import { jobQaHubPath, qaRecordPath } from './records-list/openJobQaInHub'

export function InspectionRecordLink({
  mobile,
  inspectionId,
  jobId,
  className,
  children,
}: {
  mobile: boolean
  inspectionId: string
  jobId?: string | number | null
  companySlug?: string | null
  className: string
  children: ReactNode
}) {
  void mobile
  const jobNumber = jobId != null && String(jobId) !== '' ? String(jobId) : ''
  const href = inspectionId ? qaRecordPath(inspectionId) : jobNumber ? jobQaHubPath(jobNumber) : '/records'
  return (
    <a href={href} className={className}>
      {children}
    </a>
  )
}
